import { render } from "./PruebasCorreo.vue?vue&type=template&id=b8d92e18&scoped=true"
import script from "./PruebasCorreo.vue?vue&type=script&lang=js"
export * from "./PruebasCorreo.vue?vue&type=script&lang=js"

import "./PruebasCorreo.vue?vue&type=style&index=0&id=b8d92e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d92e18"]])

export default __exports__